export default __webpack_public_path__ + "static/media/805193261245136926.9dcd2173.png";